import {i18n} from 'src/i18n';
import fields from 'src/modules/perfilEmpleado/importer/perfilEmpleadoImporterFields';
import options from 'src/modules/perfilEmpleado/importer/perfilEmpleadoImporterOptions';
import selectors from 'src/modules/perfilEmpleado/importer/perfilEmpleadoImporterSelectors';
import PerfilEmpleadoService from 'src/modules/perfilEmpleado/perfilEmpleadoService';
import importerActions from 'src/modules/shared/importer/importerActions';

const perfilEmpleadoImporterActions = importerActions(
  'PERFILEMPLEADO_IMPORTER',
  selectors,
  PerfilEmpleadoService.import,
  fields,
  i18n('entities.perfilEmpleado.importer.fileName'),
  1,
  options,
);

export default perfilEmpleadoImporterActions;
